import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IMenu } from '../../teiasoft-bucket/teiasoft-header/teiasoft-header.component';
import { withAssetVersion } from '../../utils/asset-version';

@Injectable({
  providedIn: 'root'
})
export class TeiasoftHeaderService {

  constructor(private httpClient: HttpClient) { }

  /** Header Menu */
  getHeadermenu():Observable<IMenu[]>{
    return this.httpClient.get<IMenu[]>(withAssetVersion('assets/mock/headerMenu.json'));
  }
}
